// File renderer — plan §6.3 + §11.5 E7. Dosya tipi soruda cevap = yüklenen belgeler.
// Ortak yükleme mantığı AttachmentUploader'da; burada cevap değeri (attachment_id'ler)
// senkronlanır (syncValue).

import type { QuestionSnapshot } from "@mahir/shared";
import { AttachmentUploader } from "../AttachmentUploader";

interface Props {
  question: QuestionSnapshot;
  value: string[]; // attachment_ids — pending UI için sync
  onChange: (v: string[]) => void;
}

export function FileRenderer({ question, value, onChange }: Props): JSX.Element {
  return <AttachmentUploader question={question} syncValue={{ value, onChange }} />;
}
